<template lang="pug">
    .live-filter(:class="{ 'is-active': !isClosed }")
        .filter-wrapper
            .filter-controls
                a.is-toggle(@click="toggleFilter")
                    span.icon(v-show="isClosed")
                        i.fas.fa-filter
                    span.icon(v-show="!isClosed")
                        i.fas.fa-times
                .time-filters(v-if="filterCategory === 'live'")
                    a.filter.is-unselectable(
                        v-for="time in timeFilters"
                        :title="time.title"
                        @click="timeFilter(time.level)"
                        :class=`{
                          'has-background-primary': time.level === 1,
                          'has-background-warning': time.level === 2,
                          'has-background-danger': time.level === 3,
                          'is-active': time.status
                        }`)
                        template(v-if="time.level === 0")
                            span.icon
                                i.fas.fa-stopwatch
                        template(v-else) {{ time.count }}
                .filters-separator(v-if="filterCategory === 'live'")
                .stat-filters
                    a.filter.is-unselectable(v-for="button in filterButtons" @click="save(button)"
                        :class="{ 'is-active has-background-primary': button.status }")
                        span(v-if="!$store.state.filters.isLoading") {{ button.shortTitle }}
                        span.icon(v-else)
                            i.fas.fa-spinner.fa-pulse
            .filter-settings
                .level.is-mobile
                    .level-left.level-item
                        .level.level-item
                            .level-left.level-item
                                .title.is-4 FILTERS
                            .level-right.level-item
                                .select(style="max-width:35vw")
                                    select(v-model="activeProfileId")
                                        option(v-for="profile of profiles" :value="profile._id") {{ profile.name }}

                    .level-right
                        a.is-toggle(@click.prevent="saveSettings")
                            span.icon(v-show="!$store.state.filters.isLoading")
                                i.fas.fa-save
                            span.icon(v-show="$store.state.filters.isLoading")
                                i.fas.fa-spinner.fa-pulse

                .filters-container
                    .filter(v-for="s in settings" :class="{ 'is-active': toggles[s.key] }")
                        .filter-toggle.is-unselectable(@click="toggles[s.key]=!toggles[s.key]")
                            .title.is-5 {{ s.title }}
                            a.is-toggle
                                span.icon(v-show="!toggles[s.key]")
                                    i.fas.fa-chevron-right
                                span.icon(v-show="toggles[s.key]")
                                    i.fas.fa-chevron-down
                        .filter-setting
                            .is-hidden-desktop
                                template(v-for="(arr, index) in s.settings")
                                    .title.is-5(v-if="s.titles[index]") {{ s.titles[index] }}
                                    .columns
                                        .column(v-for="(v, i) in arr")
                                            label.label.is-6 {{ s.subtitles[i] }}
                                            .control(v-if="getInputType(v) === 'radio'")
                                                .radio-group
                                                    label.radio
                                                        input(
                                                            type="radio"
                                                            :value="false"
                                                            v-model="s.settings[index][i]")
                                                        span Off
                                                    label.radio
                                                        input(
                                                            type="radio"
                                                            :value="true"
                                                            v-model="s.settings[index][i]")
                                                        span On
                                            input.input(
                                                v-else-if="getInputType(v) === 'number'"
                                                v-model.number="s.settings[index][i]"
                                                :type="getInputType(v)")
                                            input.input(
                                                v-else
                                                v-model="s.settings[index][i]"
                                                :type="getInputType(v)")
                            table.table.is-fullwidth.is-hidden-touch
                                thead
                                    tr
                                        th(v-if="s.titles.length")
                                        th(v-for="subtitle in s.subtitles") {{ subtitle }}
                                tbody
                                    tr(v-for="(arr, i) in s.settings")
                                        td(v-if="s.titles[i]")
                                            .title.is-5 {{ s.titles[i] }}
                                        td(v-for="(v, index) in arr")
                                            .control(v-if="getInputType(v) === 'radio'")
                                                .radio-group
                                                    label.radio
                                                        input(
                                                            type="radio"
                                                            :value="false"
                                                            v-model="s.settings[i][index]")
                                                        span {{ s.key === 'teamTotals' && s.titles[i] === 'Type' ? 'One Team' : 'Off' }}
                                                    label.radio
                                                        input(
                                                            type="radio"
                                                            :value="true"
                                                            v-model="s.settings[i][index]")
                                                        span {{ s.key === 'teamTotals' && s.titles[i] === 'Type' ? 'Both Team' : 'On' }}
                                            input.input(
                                                v-else-if="getInputType(v) === 'number'"
                                                v-model.number="s.settings[i][index]"
                                                :type="getInputType(v)")
                                            input.input(
                                                v-else
                                                v-model="s.settings[i][index]"
                                                :type="getInputType(v)")
</template>

<script>
export default {
  name: "LiveFilter",
  data: () => ({
    toggles: {},
    filterTimeout: null,
    activeProfileId: null
  }),
  methods: {
    timeFilter(level) {
      let filter = this.filter.timeFilters.find(f => f.level === level);
      if (filter) {
        this.filter.timeFilters.forEach(f => {
          // eslint-disable-next-line fp/no-mutation
          f.status = false;
        });
        // eslint-disable-next-line fp/no-mutation
        filter.status = true;
      }
    },
    toggleFilter() {
      this.isClosed = !this.isClosed;
    },
    getInputType(v) {
      let type = "text";

      if (typeof v === "number") {
        // eslint-disable-next-line fp/no-mutation
        type = "number";
      } else if (typeof v === "boolean") {
        // eslint-disable-next-line fp/no-mutation
        type = "radio";
      } else if (typeof v === "object") {
        // eslint-disable-next-line fp/no-mutation
        type = "checkbox";
      }

      return type;
    },
    save(filter) {
      if (this.$store.state.filters.isLoading) return;
      clearTimeout(this.filterTimeout);
      this.filterTimeout = setTimeout(() => {
        const profile = this.profiles.find(
          profile => profile.id === this.activeProfileId
        );
        if (!profile) return;
        const settingIndex = profile.settings.findIndex(
          item => item.filter === filter._id
        );
        if (settingIndex < 0) return;
        let values = profile.settings[settingIndex].values;
        const statusIndex = [...values]
          .reverse()
          .findIndex(item => typeof item[0] === "boolean");
        // eslint-disable-next-line fp/no-mutation
        if (statusIndex < 0) values = [...values, [true]];
        // eslint-disable-next-line fp/no-mutation
        else
          values[values.length - (statusIndex + 1)][0] = !values[
            values.length - (statusIndex + 1)
          ][0];
        // eslint-disable-next-line fp/no-mutation
        profile.settings[settingIndex].values = values;
        this.$store
          .dispatch("updateProfile", {
            id: this.activeProfileId,
            data: profile
          })
          .finally(() => {
            if (this.filterCategory !== "live")
              this.$store.commit("filterLoading", false);
          });
      }, 300);
    },
    saveSettings() {
      this.$store.commit("filterLoading", true);
      this.$store
        .dispatch("saveProfileSettings", this.activeProfileId)
        .finally(() => {
          setTimeout(() => {
            if (this.filterCategory !== "live")
              this.$store.commit("filterLoading", false);
          }, 1000);
        });
    },
    createToggles(list) {
      const newToggles = {};
      const toggles = this.toggles;

      if (list) {
        Object.keys(list).forEach(key => {
          const s = list[key];
          if (s) {
            const key = s.key;
            newToggles[key] = toggles[key] || false;
          }
        });
      }

      this.toggles = newToggles;
    }
  },
  watch: {
    settings(list) {
      this.createToggles(list);
    },
    profiles: {
      immediate: true,
      handler() {
        if (this.profiles[0] &&
          ((!this.activeProfileId && this.profiles.length) ||
          !this.profiles.find(item => item.id === this.activeProfileId))
        )
          this.activeProfileId = this.profiles[0]._id;
      }
    },
    activeProfileId(id) {
      this.$store.commit("activeProfileId", id);
    },
    activeStateProfileId(id) {
      if (this.profiles && this.profiles.find(item => item.id === id)) {
        this.activeProfileId = id;
      }
    }
  },
  computed: {
    activeStateProfileId() {
      return this.$store.state.profiles.activeProfileId;
    },
    isClosed: {
      get() {
        return this.$store.state.filters.isClosed;
      },
      set(value) {
        this.$store.dispatch("closeFilters", value);
      }
    },
    filterButtons() {
      const buttons = this.$store.state.filters.list.filter(f => f.showButton);
      return buttons
        .map(filter => {
          const setting = this.activeProfile.settings.find(
            setting => setting.filter === filter._id
          );
          if (setting) {
            const status = setting.values[setting.values.length - 1][0];
            if (typeof status === "boolean") {
              // eslint-disable-next-line fp/no-mutation
              filter.status = status;
            }
          }
          return filter;
        })
        .sort((a, b) => a.filterOrder - b.filterOrder);
    },
    filterCategory() {
      return this.$store.getters.filterCategory(this.$route);
    },
    filter() {
      if (!this.$store.state.filters[this.filterCategory]) return false;
      return this.$store.state.filters[this.filterCategory];
    },
    timeFilters() {
      const counter = this.$store.getters.matchTimeCounter;
      if (!counter.hasOwnProperty(this.filterCategory)) return [];
      const levels = counter[this.filterCategory] || { 1: 0, 2: 0, 3: 0 };
      const setting = this.$store.getters.timeLevelData;
      return this.filter.timeFilters.reduce((res, f) => {
        return [
          ...res,
          {
            title:
              f.level === 0
                ? "All matches"
                : `Matches from ${setting[f.level].from} to ${setting[f.level].to} minutes`,
            level: f.level,
            status: f.status,
            count: levels[f.level]
          }
        ];
      }, []);
    },
    statFilters() {
      if (!this.filter) return [];
      return this.filter.statFilters;
    },
    settings() {
      let filters = this.$store.state.filters.list;
      if (this.activeProfile) {
        const settings = this.activeProfile.settings;
        filters.map(filter => {
          const s = settings.find(item => item.filter === filter._id);
          filter.settings = s ? s.values : [];
          return filter;
        });
      }
      return filters.sort((a, b) => a.settingOrder - b.settingOrder);
    },
    profiles() {
      if (this.filterCategory === "profiles")
        return this.$store.state.profiles.list || [];
      const profiles = this.$store.state.profiles.list.filter(
        item => !!item[this.filterCategory]
      );
      return profiles || [];
    },
    activeProfile() {
      if (!this.profiles.length) return false;
      const active = this.profiles.find(
        item => item._id === this.activeProfileId
      );
      return active ? active : this.profiles[0];
    }
  },
  mounted() {
    this.createToggles(this.settings);
    if (!this.$store.state.filters.dadbee.settings.list.length)
      this.$store
        .dispatch("getFilterSettings", "dadbee")
        .catch(console.log)
        .finally(() => {
          this.$store.commit("isLoading", {
            key: "filter settings",
            status: false
          });
        });
    if (this.$store.state.filters.dadbee.isDefault)
      this.$store
        .dispatch("getFilters", "dadbee")
        .catch(console.log)
        .finally(() => {
          this.$store.commit("isLoading", {
            key: "filters",
            status: false
          });
        });
  },
  beforeDestroy() {
    this.$store.dispatch("closeFilters", true);
  }
};
</script>

<style lang="scss" scoped>
.live-filter {
  order: 4;
  height: 100%;
  background-color: #000;
  color: $defaultColor;
  overflow-y: auto;

  @media screen and (max-width: $tablet) {
    position: relative;
    order: 2;
    height: auto;
    border-top: 1px solid #666;
    overflow: initial;

    .filter-wrapper {
      flex-direction: column;
    }

    .filter-controls {
      background-color: #000;
      flex-wrap: wrap;
      flex-direction: row !important;
    }

    .is-toggle {
      order: 2 !important;
      border-bottom: none !important;
    }

    .time-filters {
      position: relative;
      flex: 1;
      order: 1 !important;
      flex-direction: row !important;
      padding-bottom: 0 !important;
      align-items: center;
      justify-content: space-around;

      .filter {
        margin-top: 0 !important;
      }

      &::after {
        content: "";
        display: block;
        position: absolute;
        width: 2px;
        height: 40%;
        background-color: #666;
        right: 0;
      }
    }

    .filters-separator {
      width: 100% !important;
      order: 3 !important;
      background-color: #666 !important;
    }
    .stat-filters {
      flex: 1 0 100%;
      align-items: center;
      justify-content: space-around;
      order: 4 !important;
      flex-direction: row !important;
      padding: 0.75rem 0 !important;

      .filter {
        margin: 0 !important;
      }
    }

    .filter-color {
      flex-direction: row;
    }

    .filter-settings {
      /*position: fixed !important;*/
      margin-left: 0 !important;
      /*top: 11rem;*/
      width: 100%;
      min-width: 100% !important;
      max-width: 100% !important;
      height: calc(100% - 11rem) !important;
      overflow-y: auto;
      background-color: #000;
      z-index: 5;

      &.is-active {
        border-left: none !important;
        border-top: 1px solid #fff;
      }
    }
  }

  &.is-active {
    .filter-settings {
      display: block;
      border-left: 1px solid #fff;
      border-right: 1px solid #fff;
      position: absolute;
      margin-left: -60rem;
      min-width: 60rem;
      max-width: 60rem;
      height: 100%;
      overflow-y: auto;
      z-index: 6;
    }
    @media screen and (max-width: $tablet) {
      .filter-wrapper {
        min-height: 1rem !important;
        height: calc(100% - 3.25rem);
        width: 100%;
        position: fixed;
        z-index: 5;
      }
      .filter-settings {
        position: relative !important;
        border-right: none !important;
        border-left: none !important;
        border-top: 1px solid #fff;
      }
    }
  }

  .is-toggle {
    display: block;
    padding: 1rem;
    color: $defaultColor;
    transition: all 0.2s linear;

    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }

  .filter-wrapper {
    display: flex;
    min-height: 100%;
  }

  .filter-controls {
    display: flex;
    flex-direction: column;

    .is-toggle {
      order: 1;
      border-bottom: 1px solid $defaultColor;
    }

    .filters-separator {
      order: 3;
      width: 60%;
      height: 2px;
      background-color: #fff;
      margin: 0 auto;
    }

    .stat-filters {
      order: 4;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 1rem;

      .filter {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2.5rem;
        height: 2.5rem;
        margin-bottom: 1rem;
        background-color: #fff;
        border: 3px solid #000;
        border-radius: 3px;
        color: #000;
        font-weight: bold;
        transition: all 0.2s linear;

        &.is-active {
          border: 0 solid transparent;
        }

        &:not(.is-active) {
          &:hover {
            border: 0 solid transparent;
          }
        }
      }
    }

    .time-filters {
      order: 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 1rem;

      .filter {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2.5rem;
        height: 2.5rem;
        margin-top: 1rem;
        border-radius: 50%;
        border: 3px solid #000;
        background-color: #eee;
        color: #000;
        font-weight: bold;
        transition: all 0.2s linear;

        &.is-active {
          border: 3px solid #fff;
        }

        &:not(.is-active) {
          &:hover {
            border: 0 solid transparent;
          }
        }
      }
    }
  }

  .filter-settings {
    flex: 1;
    display: none;
    max-width: 100%;
    width: 40rem;
    background-color: #000;

    & > .level {
      margin: 0;
      border-bottom: 1px solid #fff;

      .title {
        padding-left: 1rem;
        margin-bottom: 0;
      }

      .icon {
        margin: 0;
      }
    }

    .filters-container {
      .filter {
        background-color: #000;

        &.is-active {
          background-color: #3a4750;

          .filter-setting {
            display: block;
            border-bottom: 1px solid #fff;
          }
        }

        .filter-toggle {
          padding-left: 1rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #eee;
          cursor: pointer;

          &:hover {
            background: rgba(255, 255, 255, 0.1);
          }

          .title {
            margin-bottom: 0;
          }

          .is-toggle {
            padding: 1rem;
            color: $defaultColor;
          }
        }

        .filter-setting {
          display: none;
          padding: 1rem;

          .label {
            color: $defaultColor;
          }

          .table {
            background: none;

            thead tr th,
            tbody tr td {
              color: $defaultColor;
              border: none;
              font-weight: normal;
            }

            tbody {
              tr {
                td {
                  vertical-align: middle;

                  .title {
                    margin-bottom: 0;
                    min-width: 5rem;
                  }

                  .input {
                    background-color: #313c44;
                    border: none;
                    border-bottom: 1px solid #eee;
                    color: $defaultColor;
                    border-radius: 0;
                    box-shadow: none;

                    &:focus {
                      background-color: #293238;
                      border-bottom: 1px solid #fff;
                    }
                  }
                }
              }
            }
          }

          .radio-group {
            label.radio {
              color: $defaultColor;
              padding: 0.5rem 1rem;
              background-color: rgb(49, 60, 68);
              margin-right: 0.5rem;
              display: inline-flex;
              align-items: center;

              input[type="radio"] {
                margin-right: 0.5rem;
              }
            }
          }
        }
      }
    }
  }
}
</style>
